import React, { useState, useEffect } from 'react';
import { getPublicSettings } from '../services/api';

const DynamicFooter = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFooterData();
  }, []);

  const fetchFooterData = async () => {
    try {
      const response = await getPublicSettings();
      console.log('Footer settings response:', response);
      
      let data = {};
      
      if (response && response.data) {
        if (response.data.data && typeof response.data.data === 'object') {
          const outerData = response.data;
          const cleanData = {};
          Object.keys(outerData).forEach(key => {
            if (key !== 'data' && key !== 'success' && key !== 'message') {
              cleanData[key] = outerData[key];
            }
          });
          data = cleanData;
        } else {
          data = response.data;
        }
      } else if (response) {
        data = response;
      }
      
      console.log('Parsed footer settings:', data);
      setSettings(data);
      
    } catch (error) {
      console.error('Error fetching footer data:', error);
      setSettings({
        siteTitle: 'INTELIHEADS TECH SOLUTIONS Pvt. Ltd',
        tagline: 'AI & Robotics in Education',
        companyName: 'INTELIHEADS TECH SOLUTIONS Pvt. Ltd',
        contactEmail: 'global@inteliheads.com',
        phone: '+91-8076842489',
        address: 'Noida | Munich | Singapore',
        footerText: 'Uniting DIgSILENT, Ansys, MathWorks expertise to drive engineering breakthroughs worldwide.',
        copyrightText: `© ${new Date().getFullYear()} INTELIHEADS TECH SOLUTIONS Pvt. Ltd — Innovating Today & Empowering Tomorrow.`,
        footerBackgroundColor: '#0A192F',
        footerTextColor: '#A0B4C8',
        socialLinks: '{"linkedin":"#","twitter":"#","facebook":"#","instagram":"#"}'
      });
    } finally {
      setLoading(false);
    }
  };

  const getSocialLinks = () => {
    try {
      if (settings.socialLinks) {
        const socialStr = typeof settings.socialLinks === 'string' 
          ? settings.socialLinks 
          : JSON.stringify(settings.socialLinks);
        return JSON.parse(socialStr);
      }
    } catch (e) {
      console.error('Error parsing social links:', e);
    }
    return { linkedin: '#', twitter: '#', facebook: '#', instagram: '#' };
  };

  const socialLinks = getSocialLinks();

  if (loading) {
    return (
      <footer style={{
        background: '#0A192F',
        color: '#A0B4C8',
        padding: '3rem 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <i className="fas fa-spinner fa-spin" style={{ color: '#2C7A7B' }}></i>
          <p style={{ marginTop: '0.5rem' }}>Loading footer...</p>
        </div>
      </footer>
    );
  }

  const footerBgColor = settings.footerBackgroundColor || '#0A192F';
  const footerTextColor = settings.footerTextColor || '#A0B4C8';
  const companyName = settings.companyName || settings.siteTitle || 'INTELIHEADS TECH SOLUTIONS Pvt. Ltd';
  const tagline = settings.tagline || 'AI & Robotics in Education';
  const contactEmail = settings.contactEmail || 'global@inteliheads.com';
  const phone = settings.phone || '+91-8076842489';
  const address = settings.address || 'Noida | Munich | Singapore';
  const footerText = settings.footerText || 'Uniting DIgSILENT, Ansys, MathWorks expertise to drive engineering breakthroughs worldwide.';
  const copyrightText = settings.copyrightText || `© ${new Date().getFullYear()} INTELIHEADS TECH SOLUTIONS Pvt. Ltd — Innovating Today & Empowering Tomorrow.`;

  const quickLinks = [
    { name: 'Home', path: '#home' },
    { name: 'About Us', path: '#about' },
    { name: 'Products', path: '#products' },
    { name: 'Services', path: '#services' },
    { name: 'Training', path: '#training' },
    { name: 'Resources', path: '/resources' }
  ];

  const resourceLinks = [
    { name: 'Training Catalog', path: '/resources' },
    { name: 'Support Center', path: '/support' },
    { name: 'Documentation', path: '/docs' },
    { name: 'Case Studies', path: '/case-studies' },
    { name: 'Blog', path: '/blog' }
  ];

  const scrollToSection = (e, path) => {
    e.preventDefault();
    if (path.startsWith('#')) {
      const element = document.getElementById(path.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = path;
    }
  };

  return (
    <footer style={{
      background: footerBgColor,
      color: footerTextColor,
      padding: '4rem 0 2rem',
      marginTop: '2rem'
    }}>
      <div className="container">
        {/* Main Footer Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.6fr 0.8fr 0.8fr 1fr',
          gap: '2.5rem',
          marginBottom: '2.5rem',
          alignItems: 'start'
        }}>
          {/* Column 1: Company Info */}
          <div style={{ 
            paddingRight: '2.5rem',
            maxWidth: '480px'
          }}>
            <div style={{ marginBottom: '1.25rem' }}>
              <div style={{ 
                color: 'white', 
                fontWeight: 700, 
                fontSize: '1rem',
                lineHeight: '1.3',
                letterSpacing: '0.3px'
              }}>
                {companyName}
              </div>
              <div style={{ 
                fontSize: '0.75rem', 
                opacity: 0.7,
                marginTop: '0.3rem'
              }}>
                {tagline}
              </div>
            </div>
            
            <p style={{ 
              fontSize: '0.85rem', 
              lineHeight: '1.8',
              color: footerTextColor,
              marginBottom: '1.5rem',
              maxWidth: '380px'
            }}>
              {footerText}
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 style={{ 
              color: 'white', 
              marginBottom: '1.25rem',
              fontSize: '1rem',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }}>
              Quick Links
            </h4>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0,
              margin: 0
            }}>
              {quickLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: '0.6rem' }}>
                  <a 
                    href={link.path}
                    onClick={(e) => scrollToSection(e, link.path)}
                    style={{ 
                      color: footerTextColor, 
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                      fontSize: '0.85rem',
                      cursor: 'pointer',
                      display: 'inline-block'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#2C7A7B';
                      e.target.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = footerTextColor;
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fas fa-chevron-right" style={{ 
                      fontSize: '0.6rem', 
                      marginRight: '0.5rem',
                      opacity: 0.5
                    }}></i>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div>
            <h4 style={{ 
              color: 'white', 
              marginBottom: '1.25rem',
              fontSize: '1rem',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }}>
              Resources
            </h4>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0,
              margin: 0
            }}>
              {resourceLinks.map((link, index) => (
                <li key={index} style={{ marginBottom: '0.6rem' }}>
                  <a 
                    href={link.path}
                    onClick={(e) => scrollToSection(e, link.path)}
                    style={{ 
                      color: footerTextColor, 
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                      fontSize: '0.85rem',
                      cursor: 'pointer',
                      display: 'inline-block'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#2C7A7B';
                      e.target.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = footerTextColor;
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fas fa-chevron-right" style={{ 
                      fontSize: '0.6rem', 
                      marginRight: '0.5rem',
                      opacity: 0.5
                    }}></i>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact Us + Social Media */}
          <div>
            <h4 style={{ 
              color: 'white', 
              marginBottom: '1.25rem',
              fontSize: '1rem',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }}>
              Contact Us
            </h4>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0,
              margin: 0
            }}>
              <li style={{ 
                marginBottom: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                color: footerTextColor,
                fontSize: '0.85rem'
              }}>
                <i className="fas fa-envelope" style={{ 
                  color: '#2C7A7B',
                  width: '18px',
                  fontSize: '0.9rem'
                }}></i>
                <a 
                  href={`mailto:${contactEmail}`}
                  style={{ 
                    color: footerTextColor, 
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#2C7A7B'}
                  onMouseLeave={(e) => e.target.style.color = footerTextColor}
                >
                  {contactEmail}
                </a>
              </li>
              <li style={{ 
                marginBottom: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                color: footerTextColor,
                fontSize: '0.85rem'
              }}>
                <i className="fas fa-phone" style={{ 
                  color: '#2C7A7B',
                  width: '18px',
                  fontSize: '0.9rem'
                }}></i>
                <a 
                  href={`tel:${phone}`}
                  style={{ 
                    color: footerTextColor, 
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#2C7A7B'}
                  onMouseLeave={(e) => e.target.style.color = footerTextColor}
                >
                  {phone}
                </a>
              </li>
              <li style={{ 
                display: 'flex',
                alignItems: 'flex-start',
                gap: '0.75rem',
                color: footerTextColor,
                fontSize: '0.85rem',
                lineHeight: '1.6'
              }}>
                <i className="fas fa-map-marker-alt" style={{ 
                  color: '#2C7A7B',
                  width: '18px',
                  fontSize: '0.9rem',
                  marginTop: '0.2rem'
                }}></i>
                <span>{address}</span>
              </li>
            </ul>

            {/* Social Media Links - Below Contact Us */}
            <div style={{ marginTop: '1.5rem', paddingTop: '1rem', borderTop: `1px solid ${footerTextColor}15` }}>
              <h4 style={{ 
                color: 'white', 
                marginBottom: '0.75rem',
                fontSize: '0.85rem',
                fontWeight: 600,
                letterSpacing: '0.5px',
                opacity: 0.8
              }}>
                <i className="fas fa-share-alt" style={{ marginRight: '0.5rem', color: '#2C7A7B' }}></i>
                Follow Us
              </h4>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                {socialLinks.linkedin && socialLinks.linkedin !== '#' && (
                  <a 
                    href={socialLinks.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: footerTextColor,
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                      fontSize: '0.8rem',
                      padding: '0.3rem 0.6rem',
                      borderRadius: '6px',
                      background: 'rgba(255,255,255,0.05)',
                      border: '1px solid rgba(255,255,255,0.05)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(44,122,123,0.2)';
                      e.currentTarget.style.color = '#2C7A7B';
                      e.currentTarget.style.borderColor = '#2C7A7B';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.color = footerTextColor;
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fab fa-linkedin-in" style={{ fontSize: '0.9rem', width: '20px', color: '#0A66C2' }}></i>
                    LinkedIn
                    <span style={{ marginLeft: 'auto', fontSize: '0.6rem', opacity: 0.5 }}>→</span>
                  </a>
                )}
                {socialLinks.twitter && socialLinks.twitter !== '#' && (
                  <a 
                    href={socialLinks.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: footerTextColor,
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                      fontSize: '0.8rem',
                      padding: '0.3rem 0.6rem',
                      borderRadius: '6px',
                      background: 'rgba(255,255,255,0.05)',
                      border: '1px solid rgba(255,255,255,0.05)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(44,122,123,0.2)';
                      e.currentTarget.style.color = '#2C7A7B';
                      e.currentTarget.style.borderColor = '#2C7A7B';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.color = footerTextColor;
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fab fa-twitter" style={{ fontSize: '0.9rem', width: '20px', color: '#1DA1F2' }}></i>
                    Twitter
                    <span style={{ marginLeft: 'auto', fontSize: '0.6rem', opacity: 0.5 }}>→</span>
                  </a>
                )}
                {socialLinks.facebook && socialLinks.facebook !== '#' && (
                  <a 
                    href={socialLinks.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: footerTextColor,
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                      fontSize: '0.8rem',
                      padding: '0.3rem 0.6rem',
                      borderRadius: '6px',
                      background: 'rgba(255,255,255,0.05)',
                      border: '1px solid rgba(255,255,255,0.05)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(44,122,123,0.2)';
                      e.currentTarget.style.color = '#2C7A7B';
                      e.currentTarget.style.borderColor = '#2C7A7B';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.color = footerTextColor;
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fab fa-facebook-f" style={{ fontSize: '0.9rem', width: '20px', color: '#1877F2' }}></i>
                    Facebook
                    <span style={{ marginLeft: 'auto', fontSize: '0.6rem', opacity: 0.5 }}>→</span>
                  </a>
                )}
                {socialLinks.instagram && socialLinks.instagram !== '#' && (
                  <a 
                    href={socialLinks.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: footerTextColor,
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                      fontSize: '0.8rem',
                      padding: '0.3rem 0.6rem',
                      borderRadius: '6px',
                      background: 'rgba(255,255,255,0.05)',
                      border: '1px solid rgba(255,255,255,0.05)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(44,122,123,0.2)';
                      e.currentTarget.style.color = '#2C7A7B';
                      e.currentTarget.style.borderColor = '#2C7A7B';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.color = footerTextColor;
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fab fa-instagram" style={{ fontSize: '0.9rem', width: '20px', color: '#E4405F' }}></i>
                    Instagram
                    <span style={{ marginLeft: 'auto', fontSize: '0.6rem', opacity: 0.5 }}>→</span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          textAlign: 'center',
          paddingTop: '1.5rem',
          borderTop: `1px solid ${footerTextColor}20`,
          fontSize: '0.85rem',
          color: footerTextColor,
          opacity: 0.8
        }}>
          {copyrightText}
        </div>
      </div>
    </footer>
  );
};

export default DynamicFooter;